(ns app.domain.approval.model
  (:require [app.domain.util :as du]
            [core.db.child-entity :as child]))

(def approval-results [:approval.result/complete
                       :approval.result/complete-with-conditions
                       :approval.result/not-supported-with-comments
                       :approval.result/no-comments])


(def ^{:arglists '([approval])} approval-conditions
  (child/child-entities-of-type-fn :entity.type/approval-condition))

(defn application-conditions
  "Returns the application conditions included in an approval, in their configured order."
  [approval]
  (->> approval
       approval-conditions
       (map :approval-condition/condition)
       (sort-by :ordered/order)))


(def ^{:arglists '([approval])} approval-attachments
  (child/child-entities-of-type-fn :entity.type/file))


(def approval-results-in-submitted [:approval.result/complete
                                    :approval.result/not-complete
                                    :approval.result/no-comments])


(def all-approval-results
  (concat approval-results approval-results-in-submitted))


(def ^{:arglists '([phase-entity])} phase-approvals
  (child/child-entities-of-type-fn :entity.type/approval))


(defn open-approvals
  [work-phase creation-state]
  (cond->> work-phase
    true phase-approvals
    creation-state (filter #(= (:approval/creation-state %) creation-state))
    true (filter (du/in-state-fn :approval.state/requested :approval.state/draft))))

(defn open-approvals?
  [work-phase]
  (-> work-phase (open-approvals nil) seq))

(defn approval-delivery-status
  "Resolve approval delivery status from n amount of email statuses. If multiple statuses,
  resolve to the least negative status."
  [approval]
  (let [status-set       (->> approval :entity/related-emails (map :email-log/delivery-status) set)
        all-delivered?   (every? #{:email-log.delivery-status/delivered} status-set)
        any-delivered?   (some #{:email-log.delivery-status/delivered} status-set)
        failure-priority [:email-log.delivery-status/temporary-failure
                          :email-log.delivery-status/permanent-failure
                          :email-log.delivery-status/unknown-failure]]
    (cond
      (empty? status-set) :email-log.delivery-status/unknown
      all-delivered? :email-log.delivery-status/delivered
      any-delivered? :email-log.delivery-status/partially-delivered
      (some nil? status-set) :email-log.delivery-status/unknown
      :else (some status-set failure-priority))))
